/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import { Checkbox, Form, Input, Table, Tag, Tooltip } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import IconEmptySync from '../../../../../assets/Images/icons/empty-sync';
import ModalPersonalData from './ModalPersonalData';
import ModalSensitiveData from './ModalSensitiveData';
import ModalStoragePeriod from './ModalStoragePeriod';

const TableDataBase = ({
    databaseInfo,
    viewMode,
    form,
    disabledPeriod,
    setDisabledPeriod,
}) => {
    const { t } = useTranslation();
    const [openPersonalDataModal, setOpenPersonalDataModal] = useState(false);
    const [openSensitiveDataModal, setOpenSensitiveDataModal] = useState(false);
    const [openStoragePeriod, setOpenStoragePeriod] = useState(false);
    const [personalData, setPersonalData] = useState([]);
    const [sensitiveData, setSensitiveData] = useState([]);

    const columns = [
        {
            title: <div>{t('RoPA.Database')}</div>,
            dataIndex: 'databaseName',
            key: 'databaseName',
            width: '24%',
            render: (text) => (
                <span className="text-gray-500 font-semibold">{text}</span>
            ),
        },
        {
            title: <div>{t('RoPA.personalData')}</div>,
            dataIndex: 'personalData',
            key: 'personalData',
            width: '29%',
            render: (_, { personalData }) => (
                <>
                    {personalData?.length > 0 ? (
                        personalData.map((item, index) => {
                            if (index < 4) {
                                return (
                                    <Tag
                                        className="mb-1"
                                        style={{
                                            backgroundColor: '#DFF3FC',
                                            color: '#1890FF',
                                            border: '0px',
                                            borderRadius: '17px',
                                        }}
                                    >
                                        <div
                                            style={{
                                                overflow: 'hidden',
                                                whiteSpace: 'nowrap',
                                                textOverflow: 'ellipsis',
                                                maxWidth: '150px',
                                            }}
                                        >
                                            <Tooltip
                                                className="cursor-pointer"
                                                placement="topLeft"
                                                title={<>{item.name}</>}
                                            >
                                                {item.name}
                                            </Tooltip>
                                        </div>
                                    </Tag>
                                );
                            }
                        })
                    ) : (
                        <div className="text-gray-600">-</div>
                    )}
                    {personalData?.length > 4 && (
                        <Tag
                            className="cursor-pointer"
                            style={{
                                backgroundColor: '#B2B2B2',
                                color: '#FFFFFF',
                                border: '0px',
                                borderRadius: '17px',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis',
                                maxWidth: '150px',
                            }}
                            onClick={() => {
                                setPersonalData(personalData);
                                setOpenPersonalDataModal(true);
                            }}
                        >
                            +{personalData?.length - 4}
                        </Tag>
                    )}
                </>
            ),
        },
        {
            title: <div>{t('RoPA.sensitivePersonalDataOption')}</div>,
            dataIndex: 'sensitiveData',
            key: 'sensitiveData',
            width: '29%',
            render: (_, { sensitiveData }) => (
                <>
                    {sensitiveData?.length > 0 ? (
                        sensitiveData.map((item, index) => {
                            if (index < 4) {
                                return (
                                    <Tag
                                        className="mb-1"
                                        style={{
                                            backgroundColor: '#FFF7E6',
                                            color: '#FF6E04',
                                            border: '0px',
                                            borderRadius: '17px',
                                        }}
                                    >
                                        <div
                                            style={{
                                                overflow: 'hidden',
                                                whiteSpace: 'nowrap',
                                                textOverflow: 'ellipsis',
                                                maxWidth: '150px',
                                            }}
                                        >
                                            <Tooltip
                                                className="cursor-pointer"
                                                placement="topLeft"
                                                title={<>{item.name}</>}
                                            >
                                                {item.name}
                                            </Tooltip>
                                        </div>
                                    </Tag>
                                );
                            }
                        })
                    ) : (
                        <div className="text-gray-600">-</div>
                    )}
                    {sensitiveData?.length > 4 && (
                        <Tag
                            className="cursor-pointer"
                            style={{
                                backgroundColor: '#B2B2B2',
                                color: '#FFFFFF',
                                border: '0px',
                                borderRadius: '17px',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis',
                                maxWidth: '150px',
                            }}
                            onClick={() => {
                                setSensitiveData(sensitiveData);
                                setOpenSensitiveDataModal(true);
                            }}
                        >
                            +{sensitiveData?.length - 4}
                        </Tag>
                    )}
                </>
            ),
        },
        {
            title: <div>{t('dataFlow.StoragePeriod')}</div>,
            dataIndex: 'period',
            key: 'period',
            width: '18%',
            render: (value, row, index) => {
                return (
                    <Form.Item
                        name={['database', index, 'period']}
                        value={value}
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                    >
                        <Input
                            disabled={viewMode || disabledPeriod}
                            placeholder={t('dataFlow.PleaseSpecifyPeriod')}
                        />
                    </Form.Item>
                );
            },
        },
    ];

    const onChangeCheckbox = (e) => {
        form.setFieldsValue({ isSamePeriod: e.target.checked });
        if (e.target.checked) {
            setOpenStoragePeriod(true);
            setDisabledPeriod(true);
        } else {
            setDisabledPeriod(false);
        }
    };

    useEffect(() => {
        if (
            form.getFieldValue('isSamePeriod') &&
            form.getFieldValue('period')
        ) {
            setDisabledPeriod(true);
        } else {
            setDisabledPeriod(false);
            form.setFieldsValue({
                period: '',
            });
        }
    }, [form.getFieldValue()]);

    return (
        <>
            {databaseInfo?.database ? (
                <>
                    <div className="col-span-1 text-xs font-semibold text-gray-PHX">
                        {t('TotalItems', {
                            length: databaseInfo?.database?.length,
                        })}
                    </div>
                    <div className="col-span-1 text-xs flex justify-end">
                        <Form.Item name="isSamePeriod" valuePropName="checked">
                            <Checkbox
                                disabled={viewMode}
                                onChange={onChangeCheckbox}
                            >
                                {t('dataFlow.AllUsingStoragePeriod')}
                            </Checkbox>
                        </Form.Item>
                    </div>

                    <div className="col-span-2 bg-white rounded-xl">
                        <Table
                            // bordered
                            className="inbox_table"
                            dataSource={databaseInfo?.database}
                            columns={columns}
                            pagination={false}
                            scroll={{ y: 880 }}
                        />
                    </div>
                </>
            ) : (
                <div className="col-span-2 flex-col text-center my-48">
                    <div>
                        <IconEmptySync />
                    </div>
                    <div className="text-sm font-normal">
                        {t('dataFlow.emptyDatabase')}
                    </div>
                </div>
            )}

            <ModalStoragePeriod
                open={openStoragePeriod}
                handelClose={() => {
                    setOpenStoragePeriod(false);
                }}
                form={form}
                databaseInfo={databaseInfo}
            />

            <ModalPersonalData
                open={openPersonalDataModal}
                handelClose={() => setOpenPersonalDataModal(false)}
                personalData={personalData}
            />

            <ModalSensitiveData
                open={openSensitiveDataModal}
                handelClose={() => setOpenSensitiveDataModal(false)}
                sensitiveData={sensitiveData}
            />
        </>
    );
};
export default TableDataBase;
